module.exports = __webpack_public_path__ + "img/jybe_lg.b803b666.svg";